import { ProxySymbol } from '../values/createProxy';

import { isObject } from './isObject';

export const isProxy = <T>(value: T): value is T & { [ProxySymbol]: T } => {
   return isObject(value) && ProxySymbol in value;
};
